import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const sendEmailOtp = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/auth/email-otp`, data)
        return await response.data
    } catch (error) {
        return handleApiError(error)
    }
}

export const resendEmailOtp = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/auth/resend-email-otp`, data)
        return await response.data
    } catch (error) {
        return handleApiError(error)
    }
}

export const otpVerification = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/auth/otp-verification`, data)
        //Error also passing through response
        console.log('otp verify ',response)
        return await response.data
    } catch (error) {
        console.log('otp err', error)
        return handleApiError(error)
    }
}

export const googleAuth = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/auth/google-auth`, data)
        return await response.data
    } catch (error) {
        return handleApiError(error)
    }
}

export const googleCallBack = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/auth/google-callback`, data)
        return await response.data
    } catch (error) {
        return handleApiError(error)
    }
}

export const microsoftAuth = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/auth/microsoft-auth`, data)
        return await response.data
    } catch (error) {
        return handleApiError(error)
    }
}

export const microsoftCallback = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/auth/microsoft-callback`, data)
        return await response.data
    } catch (error) {
        return handleApiError(error)
    }
}

export const getUserDetails = async () => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/auth/user-details`)
        // console.log("getUserDetails ",response)
        return await response.data
    } catch (error) {
        return handleApiError(error)
    }
}

export const updateSessionRole = async (userRoleId, pmCompanyId) => {
    try {
        const data = { userRoleId: userRoleId, pmCompanyId: pmCompanyId }
        const response = await axios.post(`${REACT_APP_API_URL}/auth/update-session-role`, data)
        console.log("updateRole ",response)
        return await response.data
    } catch (error) {
        console.log("updateRole error",error)
        return handleApiError(error)
    }
}

export const removeSession = async () => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/auth/remove-session`)
        console.log("remove session ",response)
        return await response.data
    } catch (error) {
        return handleApiError(error)
    }
}

export const googleCallbackForSendMail = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/auth/google-sendmail-callback`, data)
        console.log("google sendmail callback ",response)
        return await response.data
    } catch (error) {
        return handleApiError(error)
    }
}

export const googleAuthenticationForSendMail = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/auth/google-sendmail-auth`, data)
        console.log("google Authentication For SendMail",response)
        return await response.data
    } catch (error) {
        return handleApiError(error)
    }
}

export const loginWithPassword = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/auth/login`, data)
        console.log("login With Password",response)
        return await response.data
    } catch (error) {
        return handleApiError(error)
    }
}

export const forgotPassword = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/auth/forgot-password`, data)
        console.log("forgot Password",response)
        return await response.data
    } catch (error) {
        return handleApiError(error)
    }
}

export const resetPassword = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/auth/reset-password`, data)
        console.log("reset Password",response)
        return await response.data
    } catch (error) {
        return handleApiError(error)
    }
}

export const getPMCompanyDetails = async () => {
    try{
        const response = await axios.get(`${REACT_APP_API_URL}/auth/pm-company`)
        return await response.data
    } catch (error){
        return handleApiError(error)
    }
}

export const isUserVerified = async () => {
    try{
        const response = await axios.get(`${REACT_APP_API_URL}/auth/is-user-verify`)
        return await response.data
    } catch (error){
        return handleApiError(error)
    }
}